import { Navigate, Outlet, useLocation } from 'react-router';

import { PantallaCarga } from '@/components/PantallaCarga';

import { useAuth } from './AuthProvider';

export function RequireAuth() {
  const { status } = useAuth();
  const location = useLocation();
  if (status === 'loading') return <PantallaCarga />;
  if (status === 'anonymous')
    return <Navigate to="/login" replace state={{ desde: location.pathname + location.search }} />;
  return <Outlet />;
}

/** Login: si ya hay sesión, a la página de inicio del staff. */
export function RedirectIfAuthenticated() {
  const { status, staff } = useAuth();
  if (status === 'loading') return <PantallaCarga />;
  if (status === 'authenticated') return <Navigate to={staff?.startUrl ?? '/'} replace />;
  return <Outlet />;
}
